import React from 'react';
import { Button, Spinner, TextButton, Typography } from 'seagull';
import { useHistory } from 'react-router-dom';
import { routes } from "../../constants";
import styles from "./NotificationActionLayout.module.scss";
import { AnchorLogo } from 'seagull/icons';
export let NotificationActionLayoutType = /*#__PURE__*/function (NotificationActionLayoutType) {
  NotificationActionLayoutType["Loading"] = "loading";
  NotificationActionLayoutType["BeforeAction"] = "beforeAction";
  NotificationActionLayoutType["AfterAction"] = "afterAction";
  return NotificationActionLayoutType;
}({});
const NotificationActionLayout = _ref => {
  let {
    state
  } = _ref;
  const history = useHistory();
  const handleRedirectToSignInPage = () => {
    history.push(routes.home);
  };
  if (state.type === NotificationActionLayoutType.Loading) {
    return /*#__PURE__*/React.createElement(Spinner, {
      "data-testid": "spinner",
      centeredInBox: true,
      centerBoxHeight: "100%"
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.notificationActionContainer
  }, state.type === NotificationActionLayoutType.AfterAction ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    weight: "normal",
    "data-testid": "notification-action-header-text"
  }, state.afterAction.header), /*#__PURE__*/React.createElement(Typography, {
    className: styles.description,
    variant: "h5",
    "data-testid": "notification-action-description-text"
  }, state.afterAction.notificationDescription)) : /*#__PURE__*/React.createElement("div", {
    className: styles.beforeActionContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    weight: "normal",
    "data-testid": "notification-before-action-header-text"
  }, state.beforeAction.header), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "approve-action-button",
    onClick: state.beforeAction.onClick,
    size: "large"
  }, state.beforeAction.buttonText))), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: styles.footer
  }, /*#__PURE__*/React.createElement(TextButton, {
    variant: "h5",
    "data-testid": "notification-action-sign-in-link",
    onClick: handleRedirectToSignInPage
  }, "Click here"), "to sign in to", /*#__PURE__*/React.createElement(AnchorLogo, {
    theme: "dark",
    height: 56
  })));
};
export default NotificationActionLayout;